import React, { useState, useEffect, useRef } from "react";
import { Box, Typography } from "@mui/material";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import StopIcon from "@mui/icons-material/Stop";
import RefreshOutlinedIcon from "@mui/icons-material/RefreshOutlined";

const RecorderHeader = () => {
  const [isRecording, setIsRecording] = useState(
    JSON.parse(localStorage.getItem("isRecording")) || false
  );
  const [seconds, setSeconds] = useState(
    Number(localStorage.getItem("seconds")) || 0
  );

  const timerRef = useRef(null);

  useEffect(() => {
    // If recording is true → resume timer
    if (isRecording) {
      timerRef.current = setInterval(() => {
        setSeconds((prev) => prev + 1);
      }, 1000);
    } else {
      clearInterval(timerRef.current);
    }

    return () => clearInterval(timerRef.current);
  }, [isRecording]);

  // Store values in localStorage whenever they change
  useEffect(() => {
    localStorage.setItem("seconds", seconds);
    localStorage.setItem("isRecording", JSON.stringify(isRecording));
  }, [seconds, isRecording]);

  const formatTime = () => {
    const hrs = String(Math.floor(seconds / 3600)).padStart(2, "0");
    const mins = String(Math.floor((seconds % 3600) / 60)).padStart(2, "0");
    const secs = String(seconds % 60).padStart(2, "0");
    return `${hrs}:${mins}:${secs}`;
  };

  const handleToggle = () => {
    setIsRecording((prev) => !prev);
  };

  const handleReset = () => {
    setSeconds(0);
    setIsRecording(false);
    localStorage.removeItem("seconds");
    localStorage.removeItem("isRecording");
  };

  return (
    <Box sx={{ display: "flex", gap: "15px", alignItems: "center", marginRight: "20px" }}>
      <Box sx={{ display: "flex", alignItems: "center", gap: "10px" }}>
        <Typography sx={{ color: "#373737", fontSize: "25px", fontWeight: "500" }}>
          {formatTime()}
        </Typography>

        <Box
          onClick={handleToggle}
          sx={{
            width: "40px",
            height: "40px",
            border: "1px solid #E5E8EB",
            background: isRecording ? "#FF3B30" : "#fff",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderRadius: "100%",
            cursor: "pointer",
            "& svg": {
              fill: isRecording ? "#fff" : "#0076FE",
              fontSize: "30px",
            },
          }}
        >
          {isRecording ? <StopIcon /> : <PlayArrowIcon />}
        </Box>
      </Box>

      <Box onClick={handleReset} style={{ cursor: "pointer" }}>
        <Typography
          sx={{
            color: "#8C8C8C",
            fontSize: "15px",
            fontWeight: "400",
            display: "flex",
            alignItems: "center",
            gap: "5px",
          }}
        >
          Last updated 30 mins <RefreshOutlinedIcon sx={{ fontSize: "18px" }} />
        </Typography>
      </Box>
    </Box>
  );
};

export default RecorderHeader;
